import React, { useState, useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const RecaptchaProvider = ({ children }) => {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for DOM to be fully ready before initializing reCAPTCHA
    if (document.readyState === 'complete') {
      setIsReady(true);
    } else {
      window.addEventListener('load', () => setIsReady(true));
      return () => window.removeEventListener('load', () => setIsReady(true));
    }
  }, []);

  // If no reCAPTCHA key configured, render children without reCAPTCHA
  if (!recaptchaSiteKey) {
    console.warn('reCAPTCHA site key not configured - running without reCAPTCHA protection');
    return <>{children}</>;
  }

  // Wait for DOM to be ready before initializing reCAPTCHA
  if (!isReady) {
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
        nonce: undefined
      }}
      container={{
        parameters: {
          badge: 'bottomright',
          theme: 'light'
        }
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaProvider;